module.exports = __webpack_public_path__ + "98892482c3c9e77b0cb1c4e9d7ba3f61.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/age-gate-bg-1024.jpg
// module id = 161
// module chunks = 0